import Box from '@mui/material/Box'

import { colorTokens } from './tokens/colors.ts'

const baseSx = {
  fontSize: 20,
  color: colorTokens.semantic.brand.base.black,
  transition: 'transform 200ms ease'
}

type KestrixChevronProps = {
  readonly expanded: boolean
  readonly size?: number
  /** Stroke colour. Defaults to black. */
  readonly color?: string
}

export const KestrixChevron = ({
  expanded,
  size = 20,
  color
}: KestrixChevronProps) => {
  return (
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      sx={[
        baseSx,
        {
          width: size,
          height: size,
          ...(color === undefined ? {} : { color }),
          transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)'
        }
      ]}
    >
      <polyline points="6 9 12 15 18 9" />
    </Box>
  )
}
